import { HeaderAlertService } from '@uxdf/direct-shared-lib';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyTileHelperService {
  private readonly localStorageRequestSentKey = 'loyaltyTileRequestSent';

  constructor(private readonly alert: HeaderAlertService) {}

  // @loyaltyDocs: save user who sent the request. Need to disable button on the tile.
  public setRequestSent() {
    localStorage.setItem(this.localStorageRequestSentKey, 'true');
  }

  // @loyaltyDocs: check if user already sent request
  public isRequestSent(): boolean {
    return JSON.parse(localStorage.getItem(this.localStorageRequestSentKey)) || false;
  }

  public alertRequestSuccess() {
    const message = $localize`:@@loyalty-tile-helper.loyaltyRequestTileRequestSuccess:Your request to access Amadeus+Me has been sent to your manager.`;
    this.alertSuccess(message);
  }

  public alertApproveSuccess() {
    const message = $localize`:@@loyalty-tile-helper.loyaltyApproveTileApproveSuccess:Your agents can now access Amadeus+Me.`;
    this.alertSuccess(message);
  }

  public alertSuccess(message: string) {
    this.alert.clean();
    this.alert.add({ type: 'success', content: message });
  }

  public alertError(message: string) {
    this.alert.clean();
    this.alert.add({ type: 'error', content: message });
  }
}
